import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty"; //@ts-check

import React from 'react';
import cx from 'classnames';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import { makeStyles } from '@material-ui/core/styles';
import HeaderCell from './HeaderCell';
var useStyles = makeStyles({
  row: {
    height: 50
  },
  isLoading: {
    '& > th': {
      borderBottom: '1px solid transparent'
    }
  }
}, {
  name: 'ECHeader'
});
/** @param {import('./types').DataGridViewDetailHeaderProps} */

var Header = function Header(_ref) {
  var columns = _ref.columns,
      isLoading = _ref.isLoading,
      sort = _ref.sort,
      by = _ref.by,
      filter = _ref.filter,
      width = _ref.width,
      onChangeSort = _ref.onChangeSort,
      onChangeFilter = _ref.onChangeFilter;
  var classes = useStyles({});
  var common = {
    sort: sort,
    by: by,
    filter: filter,
    onChangeSort: onChangeSort,
    onChangeFilter: onChangeFilter,
    width: width
  };
  return React.createElement(React.Fragment, null, React.createElement(TableHead, null, React.createElement(TableRow, {
    className: cx(classes.row, _defineProperty({}, classes.isLoading, isLoading))
  }, columns.map(function (column) {
    return React.createElement(HeaderCell, Object.assign({
      key: column.id,
      column: column
    }, common));
  }))));
};

export default Header;